/* eslint-disable @typescript-eslint/no-explicit-any */
import { Object as FabricObject } from 'fabric';

import { MenuItemWithBackup } from '../types/types';

export const colorizeObjects = ({
  color,
  targetIds,
  canvas,
  canvasId,
  addBackup,
}: MenuItemWithBackup & { color: string }) => {
  targetIds.forEach((id) => {
    const obj = canvas.getObjects().find((o: FabricObject) => o.id === id);
    if (obj) {
      obj.set('fill', color);
    }
  });
  addBackup(canvasId, canvas.toJSON());
  canvas.renderAll();
};
